<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">Many thanks to:</p>
<p class="hang">Julie Lynch, archivist at the Sulzer Regional Library, for her tireless assistance;</p>
<p class="hang">Former Sulzer Regional Library director Leah Steele for her guidance and encouragement;</p>
<p class="hang">The Ravenswood–Lake View Historical Association;</p>
<p class="hang">The Chicago History Museum Library;</p>
<p class="hang">My daughter Kathleen Butler Greenan, son-in-law Ryan Greenan and Chicago author Richard Lindberg for their support, each in their own inimitable ways; and to F. Bryan Pickett for technical support.</p>
<p class="hang">And The History Press, especially Ben Gibson, my commissioning editor, for making this happen.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?0eb06431